<template>
	<div class="page">
		<div class="searchBlock">
			<el-select v-model="type" placeholder="请选择" clearable>
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-input style="margin-left: 10px;width: 300px;margin-right: 10px;" placeholder="请输入内容" v-model="filename"
				class="input-with-select">
				<el-button slot="prepend" icon="el-icon-search" @click="getList"></el-button>
				<el-button slot="append" type="info" @click="reset">重置</el-button>
			</el-input>
			<el-dropdown>
				<el-button type="primary">
					上传材料<i class="el-icon-arrow-down el-icon--right"></i>
				</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="(item ,index) in uploadTypeList" :key="index"
						@click.native="uploadVisibleDia(item)">{{item.name}}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			<!-- <el-date-picker style="margin-right: 10px;" v-model="time" format="yyyy-MM-dd" type="datetimerange"
				:picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
				align="right" /> -->
		</div>

		<div class="table">
			<el-button @click="handleDelete()" type="danger">删除</el-button>
			<el-table ref="table" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" min-width="55">
				</el-table-column>
				<el-table-column fixed prop="filename" align="center" label="文件名称" min-width="100">
				</el-table-column>
				<el-table-column prop="format" align="center" label="文件后缀" min-width="100">
				</el-table-column>
				<el-table-column prop="type" align="center" label="类型" min-width="120">
				</el-table-column>
				<el-table-column prop="path" align="center" label="文件相对路径" min-width="480">
				</el-table-column>
				<el-table-column prop="customer_service_id" align="center" label="客服id" min-width="80">
				</el-table-column>
				<el-table-column prop="filesize" align="center" label="文件大小" min-width="120">
				</el-table-column>
				<el-table-column prop="createtime" align="center" label="创建时间" min-width="150">
				</el-table-column>
				<el-table-column fixed="right" align="center" label="操作" min-width="120">
					<template slot-scope="scope">
						<!-- slot-scope="scope" -->
						<!-- @click.native.prevent="deleteRow(scope.$index, tableData)" -->
						<el-button type="text" @click="drawer = true" size="small">
							详情
						</el-button>
						<el-button type="text" style="color: red;" @click="handleDelete(scope.row)" size="small">
							删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div class="searchBlock bottomFy" style="justify-content: space-between;">
			<div class="leftBottom searchBlock">
				<div>已勾选 {{ selection.length }} 个选项</div>
				<div style="margin-left: 10px;color: #2e4fed;cursor: pointer;" @click="isSelection(isSelected)">
					{{ isSelected ? '取消勾选全部' : '勾选全部' }}
				</div>
			</div>
			<div class="rightBottom searchBlock">
				<el-pagination :current-page="page" :page-sizes="[10, 20, 30, 40]" :page-size="10"
					layout="total,  sizes" :total="total">
				</el-pagination>
				<div class="page-wrapper">
					<el-button @click="prevPage" :disabled="page <= 1">‹</el-button>

					<div class="page-input">
						<el-input style="width: 70px;margin-right: 10px;" type="number" v-model.number="inputPage"
							@keyup.enter="jumpPage"></el-input>
						<span>/ {{ totalPage }}</span>
					</div>

					<el-button @click="nextPage" :disabled="page >= totalPage">›</el-button>
				</div>
			</div>
			<!-- @size-change="handleSizeChange" @current-change="handleCurrentChange" -->

		</div>
		<addPage :visible.sync="uploadVisible" :row="diaObj" @getList="getList"></addPage>
	</div>
</template>

<script>
	import addPage from './components/addPage.vue'
	export default {
		components: {
			addPage,
		},
		data() {
			return {
				drawer: false,
				type: '',
				uploadTypeList: [{
						type: 'image',
						name: '上传图片',
						value: 1
					},
					{
						type: 'video',
						name: '上传影片',
						value: 2
					},
					{
						type: 'music',
						name: '上传音讯',
						value: 3
					},
					{
						type: 'file',
						name: '上传附件',
						value: 4
					}
				],
				uploadVisible: false,
				options: [{
						label: '图片',
						value: '1'
					},
					{
						label: '视频',
						value: '2'
					},
					{
						label: '音讯',
						value: '3'
					},
					{
						label: '附件',
						value: '4'
					},
				],
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				time: '',
				filename: '',

				tabIndex: 'activeChat',

				page: 1,
				inputPage: 1,
				pageSize: 10,
				total: 40,
				totalPage: 4,
				tableData: [],
				selection: [],
				keyword: '',
				drawerObj: {},
				diaObj: {},
			}
		},
		computed: {
			isSelected() {
				return this.selection.length == this.tableData.length && this.tableData.length
			}
		},
		// watch: {
		// 	uploadVisible: {
		// 		immediate: true,
		// 		handler(val) {
		// 			if (!val) {
		// 				this.getList()
		// 			}
		// 		}
		// 	}
		// },
		methods: {
			tabChange(item) {
				this.tabIndex = item.type
			},
			handleSelectionChange(val) {
				this.selection = val;
			},
			prevPage() {
				if (this.page > 1) this.page--
				this.inputPage = this.page
				this.getList()
			},
			nextPage() {
				if (this.page < this.totalPage) this.page++
				this.inputPage = this.page
				this.getList()
			},
			jumpPage() {
				let p = this.inputPage
				if (p < 1) p = 1
				if (p > this.totalPage) p = this.totalPage
				this.page = p
			},
			reset() {
				this.type = ''
				this.filename = ''
				this.getList()
			},
			async getList() {
				const res = await this.$axios.get(this.$apis.getMaterialList, {
					page: this.page,
					limit: this.pageSize,
					filename: this.filename,
					type: this.type
				})
				if (res.code == 1) {
					this.tableData = res.data.list
					this.total = res.data.total
					this.totalPage = Math.ceil(this.total / this.pageSize)
				}
			},
			uploadVisibleDia(item) {
				this.diaObj = item
				this.uploadVisible = true
				console.log(this.uploadVisible)
			},
			isSelection(type) {
				if (type) {
					// 取消全选
					this.$refs.table.clearSelection()
				} else {
					// 全选
					this.tableData.forEach(row => {
						this.$refs.table.toggleRowSelection(row, true)
					})
				}
			},
			handleDelete(row) {
				let ids = row?.id ?
					row.id :
					this.selection.map(item => item.id).join(',')
				if (!ids) {
					this.$message.error('请至少选择一项!');
					return
				}
				this.$confirm('确认删除？')
					.then(() => {
						this.$axios.post(this.$apis.delMaterial, {
							ids: ids
						}).then(res => {
							if (res.code == 1) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
								this.getList()
							} else {
								this.$message.error(res.msg);
							}
						})
					})
					.catch(() => {});
			},
		},
		mounted() {
			this.getList()
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		height: 95%;
		background-color: white;
		padding: 20px 30px;

		.searchBlock {
			display: flex;
			align-content: center;
		}

		.table {
			margin: 10px 0;
		}

		.bottomFy {
			margin-top: 10px;

			.page-wrapper {
				display: flex;
				align-items: center;
				/* height: 80%; */

				.page-input {
					margin: 0px 10px;
					display: flex;
					align-items: center;
				}
			}
		}
	}
</style>